// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_6NFc5"};